import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import Footer from "../../../../Components/Footer";
import LoadingScreen from "../../../../Components/LoadingScreen";
import Loading2 from "../../../../Components/Loading2";

const AnalyticsBasedOnLocationWiseQuantitySold = () => {
  const [date, setDate] = useState(new Date().toISOString());
  var [sellocation, setSelLocation] = useState("");
  const [isloading, setisloading] = useState(true);
  const [isLoading2, setLoading2] = useState(true);
  const [Location, setLocation] = useState([]);
  const [datawithlocation, setDataWithLocation] = useState([]);
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [data, setData] = useState([]);

  useEffect(() => {
    AnalyticsBasedOnLocationWise();
    getLocation();
    setisloading(false);
  }, [sellocation, date]);

  const getLocation = () => {
    axios
      .get(`${BASEURL}/Location`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setLocation(response.data);
      })
      .catch((error) => {
        console.error("Error fetching itemcode:", error);
      });
  };

  const AnalyticsBasedOnLocationWise = () => {
    if (sellocation === "") {
      sellocation = "null";
      setLoading2(true);
      axios
        .post(
          `${BASEURL}/AnalyticsBasedOnLocationAndQuantity/${sellocation}`,
          {
            date: moment(date).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setData(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    } else {
      setLoading2(true);
      axios
        .post(
          `${BASEURL}/AnalyticsBasedOnLocationAndQuantity/${sellocation}`,
          {
            date: moment(date).format("DD/MM/YYYY"),
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((response) => {
          setLoading2(false);
          setDataWithLocation(response.data);
          console.log(response.data);
        })
        .catch((error) => {
          setLoading2(false);
          console.log(error);
        });
    }
  };
  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div>
      <div
        className="Unapp_payment"
        style={{
          display: "flex",
          justifyContent: "space-between",
          position: "sticky",
          top: "0",
          left: "0",
          zIndex: "500",
        }}
      >
        <h1 style={{ textAlign: "center" }} className="Titles">
          Tech23 Dashboards
        </h1>
        <div className="nav_1">
          <div className="back_btn">
            {" "}
            <Link
              style={{ textDecoration: "none", color: "white" }}
              to={"/StockDashboard"}
            >
              <button className="View">Back</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="h2">
        <h2>Analytics Based on Location Wise Quantity Sold</h2>
      </div>
      <div className="align1_date">
        <div className="">
          <div>
            <p> Date :</p>
          </div>
          <div>
            <input
              className="as_at"
              value={date.split("T")[0]}
              type="date"
              onChange={(e) => {
                if (e.target.value === "") {
                  alert("Please select a date");
                } else {
                  setDate(e.target.value);
                }
              }}
            />
          </div>
        </div>

        <main>
          <div className="Stock_category">
            <div className="lbl_SubCategory">
              <aside className="lbl_sub_category">
                <p>Location :</p>
              </aside>
            </div>
            <div>
              <Select
                className="Select_Category"
                onChange={(selectedOption) => {
                  if (data.length <= 0) {
                    alert("There is no data to sort!");
                  } else {
                    setSelLocation(selectedOption.value);
                  }
                }}
                value={
                  sellocation
                    ? { label: sellocation, value: sellocation }
                    : { label: "", value: "" }
                }
                options={[
                  { value: "", label: "" },
                  ...Location.map((item) => ({
                    value: item.OM_LOC_NAME,
                    label: item.OM_LOC_NAME,
                  })),
                ]}
              />
            </div>
          </div>
        </main>
      </div>

      <div style={{ width: "90%", margin: "0 auto", marginTop: "15px" }}>
        {/* <h2 style={{ fontWeight: "100" }}>REVENUE ANALYTICS</h2> */}
        {isLoading2 ? (
          <Loading2 />
        ) : (
          <>
            {sellocation && datawithlocation.length > 0 ? (
              <ReactApexChart
                options={{
                  chart: {
                    id: "line-chart", // Change the ID for the line chart
                  },
                  xaxis: {
                    categories: datawithlocation.map(
                      (item) => item.OM_ITEM_DESCRIPTION
                    ),
                    title: {
                      text: "Item Description", // X-axis label
                    },
                  },
                  yaxis: {
                    title: {
                      text: "Quantity", // Y-axis label
                    },
                  },
                  dataLabels: {
                    enabled: false, // Disable the data labels for line chart
                  },
                }}
                series={[
                  {
                    name: "Quantity",
                    data: datawithlocation.map((item) => item.QTY),
                  },
                ]}
                type="line" // Change chart type to "line"
                height={300}
              />
            ) : !sellocation && data.length > 0 ? (
              <ReactApexChart
                options={{
                  chart: {
                    id: "line-chart", // Change the ID for the line chart
                  },
                  xaxis: {
                    categories: data.map((item) => item.LOCATION),
                    title: {
                      text: "Location", // X-axis label
                    },
                  },
                  yaxis: {
                    title: {
                      text: "Quantity", // Y-axis label
                    },
                  },
                  dataLabels: {
                    enabled: false, // Disable the data labels for line chart
                  },
                }}
                series={[
                  {
                    name: "Quantity",
                    data: data.map((item) => item.QTY),
                  },
                ]}
                type="line" // Change chart type to "line"
                height={300}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "20px",
                  marginTop: "50px",
                  textDecoration: "underline",
                }}
              >
                NO RESULTS FOUND
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AnalyticsBasedOnLocationWiseQuantitySold;
